<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        name: 'modal-header',
        props: {
            title: {
                type: String,
                required: true
            },
            innerClass: {
                type: String,
                default: 'd-flex modal-header-dialog-painting justify-space-between w-100 text-h5'
            },
            dense: {
                type: Boolean,
                default: false
            },
            closeButton: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                titleBlockPadding: this.dense ? 12 : 32,
                titleInlinePadding: this.closeButton ? 7 : 54
            }
        }
    })
</script>

<template>
    <div :class="innerClass">
        {{ title }}
        <v-btn v-if="closeButton"
               aria-label="close"
               class="pa-0 modal-dismiss-button-custom"
               data-dismiss="modal"
               text
               @click="$emit('close')">
            <v-icon color="white">far fa-xmark</v-icon>
        </v-btn>
    </div>
</template>

<style>
    .inmodal .modal-header.modal-header-custom {
        padding: 0;
        display: flex;
        background-color: #f8fafb;
        border-top-left-radius: inherit;
        border-top-right-radius: inherit;
    }

    .modal-dismiss-button-custom {
        aspect-ratio: 1;
        height: 100% !important;
        margin-block-start: 7px;
    }
</style>
